// Import utilities
const {
	isDefined
} = _uo.utility;

import { sanitizeFieldAttributes } from '@builder-legacy/field/utilities';

/**
 * Modifies the UncannyAutomator.integrations object to add the conditions to an integration
 *
 * @param {Object} options                 The options
 * @param {String} options.integrationCode The integration code
 * @return {undefined}
 */
const addConditionsToIntegrations = ( { integrationCode } ) => {
	const conditions = {
		available: {},
		hasConditions: false
	};

	// Check if the conditions are loaded
	if ( isDefined( UncannyAutomator.actionsConditions ) ) {
		// Get available conditions
		// Check if this integration has available conditions
		if ( isDefined( UncannyAutomator.actionsConditions[ integrationCode ] ) ) {
			// Retrieve conditions
			conditions.available = UncannyAutomator.actionsConditions[ integrationCode ];

			// Sanitize field data
			// eslint-disable-next-line no-unused-vars
			Object.entries( conditions.available ).forEach( ( [ conditionCode, conditionData ] ) => {
				// Iterate fields
				if ( isDefined( conditions.available[ conditionCode ].fields ) ) {
					conditions.available[ conditionCode ].fields = conditions.available[ conditionCode ].fields.map(
						( fieldAttributes ) => {
							// Add the item type
							fieldAttributes.itemType = 'condition';

							// Add the integration ID
							fieldAttributes.integrationId = integrationCode;

							// Sanitize and return the attributes
							return sanitizeFieldAttributes( fieldAttributes );
						}
					);
				}
			} );

			// The integration has conditions, update the flag
			conditions.hasConditions = true;
		}
	}

	// Add conditions to the main object
	UncannyAutomator.integrations[ integrationCode ].conditions = conditions;
};

export default addConditionsToIntegrations;
